<!--
 * @Description  : 项目管理 - 待审核项目
 * @Author       : 王帅
 * @Date         : 2024-07-18 10:10:40
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-09 14:22:01
 * @FilePath     : \ngs_platform_manage_admin\src\views\project-management\to-audit-proJect-list.vue
-->
<template>
	<div class="h100 audit">
		<!-- 列表查询页 -->
		<filter-layout @search="searchName" @reset="reset" v-if="!routeQuery" hasMore hasHeader>
			<template #header>
				<el-tabs v-model="auditState1" @tab-click="tabChange(auditState1)">
					<el-tab-pane name="0">
						<span slot="label"
							>全部
							<el-badge :value="allNum" class="item"></el-badge>
						</span>
					</el-tab-pane>
					<el-tab-pane name="1">
						<span slot="label"
							>待审核
							<el-badge :value="auditNum" class="item"></el-badge>
						</span>
					</el-tab-pane>
					<el-tab-pane name="2">
						<span slot="label"
							>审核通过
							<el-badge :value="auditedNum" class="item"> </el-badge>
						</span>
					</el-tab-pane>
					<el-tab-pane name="3">
						<span slot="label"
							>驳回
							<el-badge :value="rejectProjectNum" class="item"> </el-badge>
						</span>
					</el-tab-pane>
				</el-tabs>
			</template>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="110px">
					<el-form-item label="项目名称：">
						<el-input v-model="searchForm.sname" clearable placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="业务类型：">
						<el-select v-model="searchForm.operatorsType" clearable>
							<el-option v-for="(item, index) in ywlx" :key="'业务类型' + index" :label="item.sname" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="业务来源：">
						<el-select v-model="searchForm.scope" clearable>
							<el-option
								v-for="(item, index) in ywly"
								:key="'业务来源' + index"
								:label="item.scopeName"
								:value="item.scope"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="项目创建人：">
						<el-input v-model="searchForm.publisherName" clearable placeholder="请输入"></el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef2" :model="searchForm" label-width="110px">
					<el-form-item label="创建时间：" class="date-time">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							clearable
							placeholder="请选择"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="w-table-layout w-table-page pdt10">
					<div class="w-table-content" v-show="tableShow">
						<el-table :data="filiterData" height="100%" highlight-current-row row-key="id" border ref="table">
							<el-table-column type="index" label="序号" align="center" width="70"></el-table-column>
							<el-table-column
								prop="sname"
								label="项目名称"
								header-align="center"
								min-width="150"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column
								prop="operatorsType"
								label="业务类型"
								header-align="center"
								align="center"
								min-width="110"
								show-overflow-tooltip
							>
								<template slot-scope="scope">
									<span>{{ scope.row.operatorsType | operatorsTypeFilter(ywlx) }}</span>
								</template>
							</el-table-column>
							<el-table-column
								prop="publisherName"
								label="项目创建人"
								align="center"
								header-align="center"
								min-width="150"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column
								header-align="center"
								align="center"
								prop="createDate"
								label="项目创建时间"
								min-width="160"
								show-overflow-tooltip
							>
								<template slot-scope="scope">
									<span>{{ scope.row.createDate ? scope.row.createDate.substring(0, 10) : '' }}</span>
								</template>
							</el-table-column>
							<el-table-column
								prop="scopeName"
								label="业务来源"
								header-align="center"
								align="center"
								min-width="110"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column
								prop="reviewerUserName"
								label="审核人"
								header-align="center"
								align="center"
								min-width="110"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column header-align="center" align="center" prop="sendTime" label="审核时间" show-overflow-tooltip>
								<!-- <span>{{(scope.row.isVerify === 2 && scope.row.sendTime) ? scope.row.sendTime.substring(0, 10) : '' }}</span> -->
								<template slot-scope="scope">
									<span>{{ scope.row.sendTime ? scope.row.sendTime.substring(0, 10) : '' }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="isVerify" label="状态" width="100" align="center" :resizable="false" show-overflow-tooltip>
								<template slot-scope="scope">
									<span :class="dealClass(scope.row.isVerify)">{{ scope.row.isVerify | isVerifyFilter }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" width="120">
								<template slot="header">操作</template>
								<template slot-scope="scope">
									<el-button
										v-if="scope.row.isVerify === 1 && scope.row.isFlag === 0"
										type="success"
										size="small"
										round
										plain
										class="table-btn"
										@click="audit(scope.row, 'audit')"
									>
										<svg-icon icon-class="form-examine"></svg-icon> 发布审核
									</el-button>
									<el-button v-else type="primary" size="small" round plain class="table-btn" @click="audit(scope.row, 'view')">
										<svg-icon icon-class="form-look"></svg-icon> 查看详情
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="w-table-footer">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="currentPage"
							:page-sizes="pageList"
							:page-size="pageSize"
							:total="total"
							layout="total, sizes, prev, pager, next, jumper"
						>
						</el-pagination>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<div v-else class="h100 audit operation-layout" :class="{ sHeight: routeQuery == 'projectAuditMsg' }">
			<div class="operation-main">
				<!--查看、审核 安招采-->
				<juyi-project-audit
					v-if="routeQuery == 'projectAuditMsg' && scope == '009'"
					ref="childContent"
					:isDisabled="this.$route.query.mode"
					@openDia="openDia"
					:rowData="rowData"
					:audit="isAudit"
				></juyi-project-audit>

				<xunjiang-project-audit
					v-if="routeQuery == 'projectAuditMsg' && scope == '010'"
					ref="childContent"
					:isDisabled="this.$route.query.mode"
					@openDia="openDia"
					:rowData="rowData"
					:audit="isAudit"
				></xunjiang-project-audit>

				<laowu-project-audit
					v-if="routeQuery == 'projectAuditMsg' && scope == '012'"
					ref="childContent"
					:isDisabled="this.$route.query.mode"
					@openDia="openDia"
					:rowData="rowData"
					:audit="isAudit"
				></laowu-project-audit>

				<zulin-project-audit
					v-if="routeQuery == 'projectAuditMsg' && scope == '011'"
					ref="childContent"
					:isDisabled="this.$route.query.mode"
					@openDia="openDia"
					:rowData="rowData"
					:audit="isAudit"
				></zulin-project-audit>

				<zhuanjia-project-audit
					v-if="routeQuery == 'projectAuditMsg' && scope == '013'"
					ref="childContent"
					:isDisabled="this.$route.query.mode"
					@openDia="openDia"
					:rowData="rowData"
					:audit="isAudit"
				></zhuanjia-project-audit>
			</div>
		</div>

		<!-- 审核弹框 -->
		<el-dialog :visible.sync="auditShow" width="600px" center title="审核" :close-on-click-modal="false" @close="closeDialog">
			<el-form label-width="120px" :model="checkForm" ref="checkRef" clearable :rules="checkRule">
				<el-form-item label="审核结果" prop="isVerify">
					<el-select v-model="checkForm.isVerify" @change="onChangeVerify" clearable>
						<el-option label="审核通过" value="2"></el-option>
						<el-option label="驳回" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="项目资质" v-if="rowData.scope == '009' && checkForm.isVerify == 2" prop="projectLevel">
					<el-radio-group v-model="checkForm.projectLevel" size="small">
						<el-radio v-for="(item, index) in projectLevelList" :label="item.value" :key="'项目资质' + index" border>
							{{ item.sname }}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="审核意见" prop="content">
					<el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="checkForm.content" maxlength="500" show-word-limit>
					</el-input>
				</el-form-item>
			</el-form>
			<div style="text-align: center">
				<el-button class="btn cancel-btn" size="small" @click="closeDialog">取消</el-button>
				<el-button class="btn btn-blue" type="primary" size="small" :loading="btnLoading" @click="submitCheck">提交</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { selectProjectListForJuyi, selectJuyiProjectNum, auditProjectForJuyi } from 'api/modules/projectManagement'
import { getSelectData } from 'api/modules/website'
import juyiProjectAudit from './components/juyi-project-audit'
import xunjiangProjectAudit from './components/xunjiang-project-audit'
import laowuProjectAudit from './components/laowu-project-audit'
import zulinProjectAudit from './components/zulin-project-audit'
import zhuanjiaProjectAudit from './components/zhuanjia-project-audit'

export default {
	name: 'juyi-project-list',
	components: { juyiProjectAudit, xunjiangProjectAudit, laowuProjectAudit, zulinProjectAudit, zhuanjiaProjectAudit },
	data() {
		return {
			btnLoading: false, //提交审核按钮
			auditState1: '0',
			//标签红点
			allNum: 0, //全部
			auditNum: 0, //待审核
			ingNum: 0, //进行中
			endNum: 0, //已结束
			closeNum: 0, //已关闭
			auditedNum: 0, //已审核
			rejectProjectNum: 0, //驳回

			filiterData: [],
			loading: false,
			//筛选框
			searchForm: {
				sname: '', //项目标题
				operatorsType: '', //业务类型
				// projectType: '', //项目类型
				publisherName: '', //项目创建人
				dateArr: [],
				createStartDate: '', //申请开始时间
				createEndDate: '', //申请结束时间
				// sendStartDate: '',//发布开始时间
				// sendEndDate: '',//发布结束时间
				scope: '' //聚易厅对应字段码  业务来源 009
			},
			ywlx: [
				{ sname: '项目发布', value: 0 },
				{ sname: '招募信息', value: 1 },
				{ sname: '求租信息', value: 2 },
				{ sname: '评标', value: 4 },
				{ sname: '评审论证', value: 5 }
			], //业务类型下拉数据
			ywly: [], //业务来源下拉数据
			auditState: '0',
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			auditShow: false, // 审核弹窗的显隐
			checkForm: {
				isVerify: '', //审核结果
				updateUserid: '', //当前用户id
				id: '', //审核项id
				content: '', //审核意见
				projectLevel: ''
			},
			checkRule: {
				isVerify: [{ required: true, message: '审核结果不能为空' }],
				content: [{ required: true, message: '审核意见不能为空' }],
				projectLevel: [{ required: true, message: '项目资质不能为空' }]
			},
			dataType: '',
			auditProjectMsg: {}, // 用于接收专家审核传过来的参数
			rowData: {}, // 表格操作当前行数据
			certificateList: [
				{
					id: ''
				}
			], //证书列表
			searchToggle: true, //筛选控制
			tableShow: true, //表格显隐控制
			realNameLoading: false,
			isAudit: '' //是否为审核，是则展示审核按钮
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('activeTab')) {
				this.auditState1 = JSON.parse(this.$getSessionItem('activeTab'))

				// 移除 避免污染
				this.$removeSessionItem('activeTab')
			}

			if (this.$getSessionItem('params')) {
				this.searchForm = JSON.parse(this.$getSessionItem('params'))
				this.currentPage = JSON.parse(this.$getSessionItem('params')).current
				this.pageSize = JSON.parse(this.$getSessionItem('params')).size
				this.auditState = JSON.parse(this.$getSessionItem('params')).status

				// 移除 避免污染
				this.$removeSessionItem('params')
			}
		}
		this.getData()

		this.getTabNum() //查询标签数量
		this.getgetSelectData() //业务来源下拉数据
	},
	filters: {
		ColorFilter(status) {
			const statusMap = {
				1: 'success',
				0: 'warning'
			}
			return statusMap[status]
		},
		StatusFilter(status) {
			const statusMap = {
				1: '未发起',
				4: '已发起'
			}
			return statusMap[status]
		},
		isVerifyFilter(status) {
			const statusMap = {
				1: '待审核',
				2: '审核通过',
				3: '被驳回',
				99: '撤回'
			}
			return statusMap[status]
		},
		operatorsTypeFilter(status, list) {
			let item = list.find(x => x.value == status)
			return item ? item.sname : ''
		}
	},
	methods: {
		// 处理状态
		dealClass(data) {
			let msg = ''
			switch (data) {
				case 1:
					msg = 'orange-state'
					break
				case 2:
					msg = 'green-state'
					break
				case 3:
					msg = 'red-state'
					break
				case 99:
					msg = 'gray-state'
					break
			}
			return msg
		},
		//业务来源下拉资源
		getgetSelectData() {
			getSelectData({})
				.then((d) => {
					this.ywly = d.data
				})
				.catch((err) => {})
		},
		// 关闭loading
		realClose() {
			this.realNameLoading = false
		},

		// tab切换
		tabChange(val) {
			this.currentPage = 1
			this.pageSize = 10
			if (val == 4) {
				this.auditState = ''
			} else {
				this.auditState = val
			}
			this.getTabNum()
			this.getData()
		},

		// 搜索
		searchName() {
			this.pageSize = 10
			this.currentPage = 1
			this.getTabNum()
			this.getData()
		},

		//获取标签数量
		getTabNum() {
			selectJuyiProjectNum({
				scope: this.searchForm.scope
			}).then((res) => {
				if (res.operationCode == 1) {
					this.allNum = parseInt(res.data.allProjectNum)
					this.auditNum = parseInt(res.data.auditProjectNum)
					this.auditedNum = parseInt(res.data.auditedProjectNum)
					this.rejectProjectNum = parseInt(res.data.rejectProjectNum)
				}
			})
		},

		//获得列表数据
		getData(isBack) {
			if (this.searchForm.dateArr && this.searchForm.dateArr.length > 0) {
				this.searchForm.createStartDate = this.searchForm.dateArr[0] + ' 00:00:00'
				this.searchForm.createEndDate = this.searchForm.dateArr[1] + ' 23:59:59'
			} else {
				this.searchForm.createStartDate = ''
				this.searchForm.createEndDate = ''
			}
			let params = Object.assign({}, this.searchForm)
			this.loading = true
			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize
			params.type = this.auditState

			selectProjectListForJuyi(params).then((res) => {
				if (res.operationCode == 1) {
					this.loading = false
					this.filiterData = res.data.records
					//this.filiterData = [{}]
					this.currentPage = parseInt(res.data.current)
					this.total = parseInt(res.data.total)
					this.pageSize = parseInt(res.data.size)
				}
			})
		},

		//筛选框重置
		reset() {
			this.searchForm.sname = ''
			this.searchForm.operatorsType = ''
			this.searchForm.scope = ''
			// this.searchForm.projectType = ''
			this.searchForm.publisherName = ''
			this.searchForm.dateArr = []
			this.searchForm.createStartDate = ''
			this.searchForm.createEndDate = ''
			// this.searchForm.sendStartDate = ''
			// this.searchForm.sendEndDate = ''
			this.pageSize = 10
			this.currentPage = 1
			this.getTabNum()
			this.getData()
		},

		// 点击审核
		audit(data, type) {
			let queryType = 'projectAuditMsg' // 审核页面，支持审核及查看
			let params = Object.assign({}, this.searchForm)
			params.current = this.currentPage
			params.size = this.pageSize
			params.status = this.auditState

			// 存值
			this.$setSessionItem('params', JSON.stringify(params))
			this.$setSessionItem('activeTab', JSON.stringify(this.auditState1))

			// 列表数据
			this.rowData = data
			if (type === 'audit') {
				this.isAudit = type //标记为审核
			} else if (data.isVerify === 3) {
				//审核不通过，查看页面为审核页面，无审核按钮
				this.isAudit = type //标记为查看
			} else {
				// 不满足上述条件，则项目正常，查看项目进度页面
				this.isAudit = type //标记为查看
				//queryType = 'projectViewMsg' //跳转页面至多tab的详情页
			}

			// 页面跳转 to-audit-proJect-list
			this.$router.push({
				name: 'to-audit-proJect-list',
				query: {
					type: queryType,
					mode: type,
					scope: this.rowData.scope
				}
			})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getTabNum()
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getTabNum()
			this.getData()
		},

		// 审查提交
		submitCheck() {
			this.$refs.checkRef.validate((valid) => {
				if (valid) {
					this.btnLoading = true
					// 审核参数
					let params = Object.assign({}, this.auditProjectMsg)
					this.checkForm.id = params.id

					//审核提交
					auditProjectForJuyi(this.checkForm).then((d) => {
						if (d.code == 0) {
							if (d.operationCode == 1) {
								this.checkForm.isVerify == 2 ? this.$message.success('审核成功') : this.$message.success('已驳回')
							} else {
								this.$message.error(d.msg)
							}

							this.$router.push({ path: 'to-audit-proJect-list' })
							this.auditShow = false
							this.btnLoading = false
							this.getTabNum()
							this.getData()
							this.$refs.checkRef.resetFields()
						} else {
							this.btnLoading = false
						}
					})
				} else {
					this.$message.warning('您有必填项未填写')
				}
			})
		},

		// open 审查弹框
		openDia(data) {
			this.auditShow = true
			this.auditProjectMsg = data
		},

		// close 审查弹框
		closeDialog() {
			this.auditShow = false
			this.$refs.checkRef.resetFields()
			this.checkForm.remark = ''
		},

		// 切换状态
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		//审核结果切换
		onChangeVerify(value) {
			if (value == 2) {
				this.checkForm.content = '通过'
			} else {
				this.checkForm.content = ''
			}
		},

		// 审核状态格式化
		verifyFormatter(row, column, cellValue, index) {
			let verifyName = ''
			if (row.isFlag === 1) {
				verifyName = '已撤回'
			} else {
				switch (cellValue) {
					case 0:
						verifyName = '保存'
						break
					case 1:
						verifyName = '待审核'
						break
					case 2:
						verifyName = '审核通过'
						break
					case 3:
						verifyName = '驳回'
						break
					default:
						verifyName = '运营下架'
						break
				}
			}
			return verifyName
		}
	},
	computed: {
		...mapState('app', {
			clientSize: (state) => state.clientSize,
			isBack: (state) => state.isBack
		}),

		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),

		...mapState('user', { userInfo: (state) => state.userInfo }),

		...mapState('dict', {
			projectLevelList: (state) => state.projectQualification,
			yyyw: state => state.projectDict.yyyw
		}),

		routeQuery() {
			return this.$route.query.type
		},
		scope() {
			return this.$route.query.scope
		}
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		},

		// 监听路由参数 --- 回到主界面时刷新查询
		$route(params) {
			let arr = Object.keys(params.query)
			if (arr.length === 0) {
				this.getTabNum()
				this.getData()
			}
		}
	}
}
</script>

<style scoped lang="less">
.audit {
	.searchBox {
		padding-top: 8px;
	}
	/deep/ .more-layout {
		top: 55px;
		right: 370px;
	}
	/deep/ .el-tabs__item {
		width: 100px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		background: #f0f0f0;
		border-radius: 3px 3px 0px 0px;
		color: #666;
		margin-right: 20px;
		padding: 0;
		.el-tabs__header {
			border-bottom: 1px solid #2671cc;
		}
	}
	/deep/ .el-tabs__item.is-active {
		color: #fff;
		background-color: #2671cc !important;
	}
	/deep/ .el-tabs__nav-wrap::after {
		background-color: #2671cc;
		height: 1px;
		z-index: 999;
	}
	/deep/ .el-tabs__active-bar {
		background-color: transparent;
	}
	.auditMsg {
		color: #2671cc;
		cursor: pointer;
	}
	.green,
	.red,
	.orange {
		display: inline-block;
		height: 28px;
		line-height: 28px;
		padding: 0 10px;
		font-size: 12px;
		border-radius: 5px;
	}
	.green {
		background: #e9f6f2;
		border: 1px solid #bff5e5;
		color: #39c098;
	}
	.red {
		background: #feeff0;
		border: 1px solid #fde2e2;
		color: #f56c6c;
	}
	.orange {
		background: #fdf6ec;
		border: 1px solid #faecd8;
		color: #e7a23c;
	}
	.toolbar {
		position: relative;
		.toolbar-right {
			position: absolute;
			right: 0;
			top: 0;
		}
	}
	/deep/ .el-table__header-wrapper {
		tr > th {
			padding: 6px 0 !important;
			height: 50px !important;
		}
	}
	.item {
		position: absolute !important;
		right: -15px;
	}
}
.sHeight {
	padding: 0;
}
</style>
